import { render } from "./AddImo1Component.vue?vue&type=template&id=ea4d76be"
import script from "./AddImo1Component.vue?vue&type=script&lang=js"
export * from "./AddImo1Component.vue?vue&type=script&lang=js"

import "./AddImo1Component.vue?vue&type=style&index=0&id=ea4d76be&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__